<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M12 3.75C11.5858 3.75 11.25 3.41421 11.25 3C11.25 2.58579 11.5858 2.25 12 2.25H17C17.1017 2.25 17.1987 2.27024 17.2871 2.30691C17.3755 2.34351 17.4584 2.39776 17.5303 2.46967C17.6022 2.54158 17.6565 2.62445 17.6931 2.71291C17.7298 2.80134 17.75 2.89831 17.75 3V8C17.75 8.41421 17.4142 8.75 17 8.75C16.5858 8.75 16.25 8.41421 16.25 8V4.81066L12.5303 8.53033C12.2374 8.82322 11.7626 8.82322 11.4697 8.53033C11.1768 8.23744 11.1768 7.76256 11.4697 7.46967L15.1893 3.75H12Z"
            fill="#8E8E93"
        />
        <path
            d="M3.75 15.1893V12C3.75 11.5858 3.41421 11.25 3 11.25C2.58579 11.25 2.25 11.5858 2.25 12V17C2.25 17.1017 2.27024 17.1987 2.30691 17.2871C2.34351 17.3755 2.39776 17.4584 2.46967 17.5303C2.54158 17.6022 2.62445 17.6565 2.71291 17.6931C2.80134 17.7298 2.89831 17.75 3 17.75H8C8.41421 17.75 8.75 17.4142 8.75 17C8.75 16.5858 8.41421 16.25 8 16.25H4.81066L8.53033 12.5303C8.82322 12.2374 8.82322 11.7626 8.53033 11.4697C8.23744 11.1768 7.76256 11.1768 7.46967 11.4697L3.75 15.1893Z"
            fill="#8E8E93"
        />
    </svg>
</template>
